<template>
  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.87876 4.29285C9.26929 3.90242 9.90232 3.90235 10.2928 4.29285C10.6831 4.68336 10.6832 5.31645 10.2928 5.70691L5.99985 9.99988H17.5858C18.1379 10 18.5858 10.4477 18.5858 10.9999C18.5857 11.552 18.1379 11.9997 17.5858 11.9999H5.99985L10.2928 16.2928C10.6831 16.6834 10.6832 17.3164 10.2928 17.7069C9.90236 18.0974 9.2693 18.0972 8.87876 17.7069L3.58579 12.4139C2.80474 11.6329 2.80474 10.3669 3.58579 9.58581L8.87876 4.29285Z" fill="white"/>
    </svg>
</template>

<script>

export default {
  name: 'ArrowBackIcon',
  components: {
  },
  props: {
  },
  setup () {
  }
}
</script>

<style lang="scss" scoped>

</style>
